<template>
  <div id="notFound">
    <div>40411 Page</div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  created() {
    this.init()
  },
  watch: {

  },
  methods: {
    init() {

    },
  },
}
</script>

<style lang="less" scoped>
#notFound {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
